<template>
	<el-dialog title="产品选择" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
		:visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="1200px"
		@close="dialogClose" v-el-drag-dialog v-el-dialog-center>
		<template>
			<div id="containt">
				<div class="grid-height" style="display:flex">
					<!-- 左边------- 树型结构 -->
					<div class="left_tree">

						<div
							style="padding: 5px;margin: 2px 8px;overflow-y: scroll;height: 560px;border: 1px solid #ededed;">
							<div class="title"> <svg t="1676961094129" class="icon tree_icon" viewBox="0 0 1024 1024"
									version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2887" width="20" height="20">
									<path
										d="M384 725.333333c0 21.333333 17.066667 38.4 38.4 42.666667H640v-42.666667c0-21.333333 17.066667-38.4 38.4-42.666666H853.333333c25.6 0 42.666667 17.066667 42.666667 42.666666v170.666667c0 25.6-17.066667 42.666667-42.666667 42.666667h-170.666666c-25.6 0-42.666667-17.066667-42.666667-42.666667v-42.666667h-213.333333c-68.266667 0-123.733333-51.2-128-119.466666V341.333333H170.666667c-21.333333 0-38.4-17.066667-42.666667-38.4V128c0-25.6 17.066667-42.666667 42.666667-42.666667h341.333333c25.6 0 42.666667 17.066667 42.666667 42.666667v170.666667c0 25.6-17.066667 42.666667-42.666667 42.666666H384v128h256v-42.666666c0-21.333333 17.066667-38.4 38.4-42.666667H853.333333c25.6 0 42.666667 17.066667 42.666667 42.666667v170.666666c0 25.6-17.066667 42.666667-42.666667 42.666667h-170.666666c-25.6 0-42.666667-17.066667-42.666667-42.666667v-42.666666H384v170.666666z m426.666667 42.666667h-85.333334v85.333333h85.333334v-85.333333z m0-298.666667h-85.333334v85.333334h85.333334v-85.333334z m-341.333334-298.666666H213.333333v85.333333h256V170.666667z"
										fill="#1296db" p-id="2888"></path>
								</svg>

								<span>商品分类</span>
							</div>
							<el-input placeholder="关键字过滤" v-model="filterText">
							</el-input>

							<el-tree class="tree-line" :data="data" lazy :load="loadChildNode" :props="defaultProps"
								@node-click="handleNodeClick" :filter-node-method="filterNode" ref="tree" v-if="isRouterAlive">
							</el-tree>
						</div>
					</div>
					<div class="table_main">
						<vxe-grid ref="table-m1" :radio-config="{ highlight: true }"
						@cell-click="cellClickEvent"
							@radio-change="radioChangeEvent"
							show-overflow height="550" :row-config="{ isHover: true }"
							v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
							@custom="$vxeTableUtil.customHandle">

							<template #form>
								<div class="clearfix screen-btns">
									<div class="fr">
										<vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text"
											status="primary" plain>重置</vxe-button>
										<vxe-button status="warning" icon="el-icon-search" class="button-sty"
											@click="searchEvent">搜索</vxe-button>
									</div>
								</div>
								<vxe-form ref="form" class="screen-box" title-width="92px" title-align="right"
									:data="formData" @submit="searchEvent" @reset="searchEvent">
									<vxe-form-item title="品牌名称:" field="brandName">
										<template v-slot>
											<el-input v-model="searchBrandName" size="small" clearable />
										</template>
									</vxe-form-item>
									<vxe-form-item title="产品编码:" field="itemCode">
										<template v-slot>
											<el-input v-model="searchItemCode" size="small" clearable />
										</template>
									</vxe-form-item>
									<vxe-form-item title="产品名称:" field="itemName">
										<template v-slot>
											<el-input v-model="searchItemName" size="small" clearable />
										</template>
									</vxe-form-item>
								</vxe-form>
							</template>
							<template #pager>
								<pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
							</template>
						</vxe-grid>
					</div>
				</div>
			</div>
		</template>
		<span slot="footer" class="dialog-footer">
			<span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>
			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="commitRow" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { selectDialogMixins } from '@/mixins/selectDialog/index.js';
import { initVxeTable } from '@/const/crud/admin/table'

import { fetchTree } from "@/api/admin/type_tree";
import pager from '@/components/pager/index.vue'
export default {
	name: 'saleConfigDialog',
	props: ['visiable', 'multi', 'param'],
	mixins: [selectDialogMixins],
	components: { pager },

  created() {
    this.initSetting();
  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    total(newVal, oldVal) {
      this.$refs.pager.tableDataTotal = newVal
    }
  },

	data() {
		return {
      total: 0,
			filterText: '',
			data: [],
			defaultProps: {
				children: 'children',
				label: 'label',
				id: "id",
				isLeaf: "leaf"
			},
			pageSizes: [10, 20, 100],
			//以上树形
			activeName: 'second',
			dataId: 0,
			showEdit: false,
			vxeOption: {},
      isRouterAlive: true,
			// 查询参数
			formData: {
				size: 0,
				current: 1,
				searchCount: false,
				brandName: "",
				itemCode: "",
				itemName: "",
				bigCategoryId: '',
				smallCategoryId: '',
			},
			showDialog: true,
			falseValue: false,
			selectMulti: true,
      searchItemName: '',
      searchItemCode: '',
      searchBrandName: '',
      selectedRow: {
        id: '', name: ''
      }
		};
	},


	methods: {
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

		cellClickEvent (e) {
      console.log(e.row.id,'单元格点击事件')
    },


    radioChangeEvent ({ row }) {
      this.selectedRow = {id: row.id, name: row.itemName}
    },


    commitRow() {
			this.$emit('commitSelectedRow', this.selectedRow)
      this.dialogClose()
		},


		// 分页功能
		changeTablePage(page, flag) {
			this.formData.size = page.pageSize
			this.formData.current = page.currentPage
			this.formData.searchCount = flag
			this.initTableList();
		},

		filterNode(value, data) {
			if (!value) return true;
			return data.label.indexOf(value) !== -1;
		},

		// 搜索
		searchEvent() {
      this.formData.itemCode = this.searchItemCode
      this.formData.itemName = this.searchItemName
      this.formData.brandName = this.searchBrandName
			this.$refs.pager.clearStoreTableDataTotal()
			this.formData.current = 1
      this.formData.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
			this.flushed()
		},

		// 重置
		resetEvent() {
      this.searchItemCode = ''
      this.searchItemName = ''
      this.searchBrandName = ''
      this.formData.itemCode = ''
      this.formData.itemName = ''
      this.formData.brandName = ''
			this.formData.current = 1
      this.formData.searchCount = false
      this.formData.bigCategoryId = ''
      this.formData.smallCategoryId = ''
			this.$refs.pager.reset()  // 重置分页器
			this.flushed()
      this.reloadTree()
		},


		// 新增
		openEditDialog(id) {
			this.dataId = !id || typeof id == 'object' ? 0 : id;
			this.activeName = 'first';
			this.$openEditView('showEdit');
		},


    reloadTree(){
      this.isRouterAlive = false
      this.$nextTick(function(){
        this.isRouterAlive = true
      })
    },

		// 点击的树形 点
		handleNodeClick(node, data) {
			let id = data.data.id;
			if (data.level === 1) {
				this.formData.bigCategoryId = id;
				this.formData.smallCategoryId = '';
			} else {
				this.formData.smallCategoryId = id;
			}

			this.initTableList();
			this.flushed()
		},

		initTableList() {
			let tableOption = {
				vue: this,
				tableRef: 'table-m1',
				tableName: 'basic_fault_code_list-m1',
				path: '/basic/basItem/getListPage',
				param: this.formData,
				method: 'post',
				columns: [
					{ type: "radio", width: 40, title: '', resizable: false, fixed: 'left' },
					{
						title: '品牌名称',
						field: 'brandName',
						width: 110,
						// fixed: 'left'
					},
					{
						title: '产品编码',
						field: 'itemCode',
						width: 110,
					},
					{
						title: '产品名称',
						field: 'itemName',
						width: 110,
					},
					{
						title: '产品型号',
						field: 'itemModel',
						width: 110,
					},
					{
						title: '产品大类',
						field: 'bigCategoryName',
						width: 110,
					},
					{
						title: '产品小类',
						field: 'smallCategoryName',
						width: 110,
					},
					{
						title: '是否结算',
						field: 'isSettle',
						width: 110,
						slots: {
							default: ({ row }) => {
								if (row.isSettle == 0) {
									return [
										<div class="txt-status disable">
											<span>否</span>
										</div>
									];
								} else if (row.isSettle == 1) {
									return [
										<div class="txt-status">
											<span>是</span>
										</div>
									];
								}
							}
						}
					},
					{
						title: '启用状态',
						field: 'usable',
						width: 110,
						slots: {
							default: ({ row }) => {
								if (row.usable == 0) {
									return [
										<div class="txt-status disable">
											<span>禁用</span>
										</div>
									];
								} else if (row.usable == 1) {
									return [
										<div class="txt-status">
											<span>启用</span>
										</div>
									];
								}
							}
						}
					},


					{
						field: 'createTime',
						title: '创建时间',
						width: 110
					},
					{
						title: '创建人',
						field: 'createBy',
						width: 110,

					},

				]
			};
			this.vxeOption = initVxeTable(tableOption);
      this.flushed()
		},


		// 加载页面
		loadChildNode(node, resolve) {
			fetchTree({
        parentId: node.data.id,
        categoryType: 1
      }).then(({ data }) => {
				console.log(data, "data.data的值"),
					resolve(
						data.data.map(item => {
							return {
								label: item.categoryName,
								id: item.id,
								leaf: Number(item.isChild) == 1 ? false : true,
							}
						})
					)
			});
		},

	}
};
</script>
<style lang="scss" scoped>
// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
	top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
	top: 0.3em;
}

#containt .grid-height {
	height: 570px;
}

::v-deep .el-dialog {
	// height: 700px;
	overflow: hidden;
}

::v-deep body .dialog-style {
	border-radius: 8px;
	-webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
	box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
	// height: 700px;
	overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
	.el-radio__inner {
		border: 0px;
		background: transparent;
	}

	.el-radio__input.is-checked .el-radio__inner {
		background: none;
	}

	.el-radio {
		height: 100%;
		width: 150px;
		position: absolute;
		z-index: 10;
	}
}

.table_main {
	padding-top: 5px;
	padding-left: 5px;
	border: 1px solid #ededed;
	width: calc(100% - 215px);
	border-bottom: none;

	.el-pagination {
		padding: 2px;

	}
}

.left_tree {
	width: 205px;

	.title {
		text-align: left;
		width: 182px;
		padding: 7px 0 5px !important;
		font-size: 13px;
		color: rgba(58, 39, 39, 0.96);

		>span {
			position: relative;
			left: 4px;
			top: -3px;
		}
	}

	::v-deep.el-tree-node__label {
		width: calc(100% - 32px);
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 12px;
		color: rgba(86, 86, 86, 0.96);
	}
}

.tree_icon {
	background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
	.el-tree-node {
		position: relative;
		padding-left: 0px;
	}

	.el-tree-node__content {
		margin-top: 0px;
	}

	.el-tree-node__children {
		padding-left: 16px;
	}

	.el-tree-node::before {
		content: '';
		height: 100%;
		width: 1px;
		position: absolute;
		left: -3px;
		top: -26px;
		border-width: 1px;
		border-left: 1px dashed #d9d9d9;
	}

	.el-tree-node:last-child::before {
		height: 38px;
	}

	.el-tree-node::after {
		content: '';
		width: 24px;
		height: 1px;
		position: absolute;
		left: -3px;
		top: 12px;
		border-width: 1px;
		border-top: 1px dashed #d9d9d9;
	}

	&>.el-tree-node::after {
		border-top: none;
	}

	&>.el-tree-node::before {
		border-left: none;
	}

	.el-tree-node__expand-icon {
		font-size: 17px;

		// color: #000;
		&.is-leaf {
			color: transparent;
			// display: none;
		}
	}
}
</style>
